import axios from "axios";


const GetEmployeeCategoryList = async () => {
  return axios.get(`EmployeeCategory/GetEmployeeCategories`).then((response) => response);
};


const AddEmployeeCategory = async (payload) => {
  const config = {
    method: "post",
    url: `EmployeeCategory/AddEmployeeCategory`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};


const UpdateEmployeeCategory = async (payload) => {
  const config = {
    method: "post",
    url: `EmployeeCategory/UpdateEmployeeCategory`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const employeeCategoryService = {
  GetEmployeeCategoryList,
  AddEmployeeCategory,
  UpdateEmployeeCategory,
};

export default employeeCategoryService;
